import ControlledInput from '../../../components/ControlledInput';
import * as React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { ControlledTextArea } from '../../../components/Textarea';
import { useUserStore } from '../../../stores';
import { generateMessageForTelegram } from '../services/sendNotifyToTelegram';
import BtnFilled from '../../../components/BtnFilled';
import { sendFormToTelegram } from '../../../api/telegram_notifications_api';
import useThrottle from '../../../utils/use-throttle';

const initialForm = { city: '', address: '', company: '', website: '', comments: '' };

const IntegrationRequestForm = () => {
  const methods = useForm({ mode: 'onChange', defaultValues: initialForm });
  const { user } = useUserStore();

  const inputsFields = [
    { name: 'city', label: 'Город', placeholder: 'Укажите город', type: 'text', required: true },
    { name: 'address', label: 'Адрес', placeholder: 'Укажите ваш адрес', type: 'text', required: true },
    { name: 'company', label: 'Управляющая компания', placeholder: 'Название УК', type: 'text', required: true },
    { name: 'website', label: 'Сайт для передачи показаний', placeholder: 'Укажите сайт', type: 'text', required: false },
    { name: 'comments', label: 'Комментарии', placeholder: 'Добавьте комментарии/уточняющую информацию', type: 'textArea', required: false },
  ];

  const handleSuccess = useCallback(() => {
    toast.success('Ваша заявка принята, мы обязательно свяжемся с Вами!');
    methods.reset();
  }, [methods]);

  const handleError = useCallback(() => {
    toast.error('Произошла ошибка во время отправки');
  }, []);

  const handleSubmit = useThrottle(async (data) => {
    const text = generateMessageForTelegram(data, user);
    await sendFormToTelegram({ text }, handleSuccess, handleError);
  }, 1000);

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        {inputsFields.map((input) => {
          const { required, ...restInput } = input;
          if (input.type === 'textArea') {
            return <ControlledTextArea rows={4} key={input.name} {...restInput} />;
          } else {
            return (
              <ControlledInput
                rules={{
                  required: {
                    value: required,
                    message: 'Поле обязательно для заполнения',
                  },
                }}
                key={input.name}
                {...restInput}
              />
            );
          }
        })}
        <BtnFilled className={'bg-orange-500 max-w-[200px] m-auto flex justify-center'} title={'Отправить'} type={'submit'} />
      </form>
    </FormProvider>
  );
};

export default IntegrationRequestForm;
